import AddBankAccount from "./Components/AddBankAccount.tsx";
import Subscriptions from "./Components/Subscriptions.tsx";
import YourAccounts from "./Components/YourAccounts.tsx";
import { RootState, useAppSelector } from "../../../../state/state.tsx";
import { Link, useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../../state/ModalSlice/ModalSlice.ts';
import TodaysSummary from './Components/TodaysSummary';
import WindingDownBanner from './Components/WindingDownBanner';
import { selectActiveRole, selectBankAccounts, selectEffectiveUID } from "../../../../state/UserStatesV2/userSliceV2.ts";
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import HistoryIcon from '@mui/icons-material/History';
import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../../../Config/firebase';
import { 
    Button
} from '@mui/material';

export default function MySubscriptions() {
    const BankAccounts = useAppSelector(selectBankAccounts);
    const userName = useAppSelector((state: RootState) => state.userSliceV2.data?.display_name);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const activeRole = useAppSelector(selectActiveRole);
    const ServiceProviderID = useAppSelector(selectEffectiveUID);
    const [checkingSlots, setCheckingSlots] = useState(true);
    const [hasSubscriptionsWithSlots, setHasSubscriptionsWithSlots] = useState(false);
    const [markupClassesCount, setMarkupClassesCount] = useState(0);
    const [checkingMarkupClasses, setCheckingMarkupClasses] = useState(true);
    


    // Effect to check for subscriptions with slots
    useEffect(() => {
        const checkForSlots = async () => {
            if (!ServiceProviderID) return;
            
            try {
                // Fetch subscriptions first
                const subscriptionsRef = collection(db, `ServiceProviders/${ServiceProviderID}/Subscriptions`);
                const subscriptionsSnap = await getDocs(subscriptionsRef);
                
                let found = false;
                for (const subscriptionDoc of subscriptionsSnap.docs) {
                    const slotsRef = collection(db, `ServiceProviders/${ServiceProviderID}/Subscriptions/${subscriptionDoc.id}/Slots`);
                    const slotsSnap = await getDocs(slotsRef);
                    
                    if (!slotsSnap.empty) {
                        found = true;
                        break;
                    }
                }
                setHasSubscriptionsWithSlots(found);
            } catch (error) {
                console.error('Error checking for slots:', error);
            } finally {
                setCheckingSlots(false);
            }
        };

        checkForSlots();
    }, [ServiceProviderID]);

    // Effect to fetch markup classes count (only today's scheduled ones)
    useEffect(() => {
        const fetchMarkupClassesCount = async () => {
            if (!ServiceProviderID) return;
            
            try {
                setCheckingMarkupClasses(true);
                const markupRef = collection(db, `ServiceProviders/${ServiceProviderID}/markup`);
                const markupSnap = await getDocs(markupRef);
                const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
                const todayScheduledCount = markupSnap.docs.filter(doc => {
                    const data = doc.data();
                    return data.status === 'scheduled' && data.scheduledDate === today;
                }).length;
                setMarkupClassesCount(todayScheduledCount);
            } catch (error) {
                console.error('Error fetching markup classes count:', error);
            } finally {
                setCheckingMarkupClasses(false);
            }
        };

        fetchMarkupClassesCount();
    }, [ServiceProviderID]);






    return (
        <div>
            <div className={"pl-4"}>
                {/*-------------------Important Update Banner-------------------*/}
                <WindingDownBanner />

                {/*-------------------Greeting and Search-------------------*/}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mt-4 mb-4 pr-2 sm:pr-4">
                    <p className={"text-base sm:text-[1.2rem]"}>
                        <span className={"font-semibold"}>Hey {userName ? userName : ""}</span>
                        <span className={"text-gray-500 hidden sm:inline"}> - Here's what happening in your account today</span>
                        <span className={"text-gray-500 sm:hidden"}> - Today's overview</span>
                    </p>

                    {activeRole?.role !== "Observer" && <Link
                        to="/subscriptions"
                        className="flex items-center gap-2 px-3 sm:px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 group text-sm sm:text-base w-full sm:w-auto justify-center"
                    >
                        <SearchIcon className="text-lg sm:text-xl group-hover:scale-110 transition-transform duration-200" />
                        <span className="font-medium">Global Students Search</span>
                    </Link>}
                </div>

                <div className={"grid grid-cols-1 lg:grid-cols-4 gap-4"}>
                    {/*--------------Grid Left Potion------------*/}
                    <div className={"home-left lg:col-span-3 p-2"}>
                        {/*-------------------Add Bank Account-----------*/}
                        {BankAccounts?.length === 0 && activeRole?.role === null && <AddBankAccount />}

                        {/* Today's Summary */}
                        {activeRole?.role !== "Observer" ? <TodaysSummary /> : <div className="text-center p-6 text-gray-600 font-bol bg-gray-50 rounded-lg">
                            <h2 className="text-3xl font-bold text-gray-500 mb-4 ">You are logged in as an Coach</h2>
                            <p className="text-base">You have access to view student and manage attendance records.</p>
                        </div>}

                        {/*-------------------Subscriptions--------------*/}
                        <Subscriptions />
                    </div>
                    <div className={"home-right mt-16"}>
                        {/* Quick Links Section */}
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
                            <h2 className="text-lg font-semibold mb-4 text-gray-800">Quick Links</h2>
                            {activeRole?.role !== "Observer" ? <div className="space-y-3">
                                {/* Add Slots Launch Point - Only for Owner and Admin */}
                                {(!activeRole?.role || activeRole?.role === "Administrator") && (
                                    <div 
                                        onClick={() => navigate('/slots')} 
                                        className="bg-gray-50 px-1 py-3 rounded-lg hover:bg-cc_brand/5 transition-all duration-200 group cursor-pointer"
                                    >
                                        <div className="flex justify-between items-center">
                                            <div className="flex items-center gap-3">
                                                <svg className="w-6 h-6 text-cc_brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"></rect>
                                                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2"></line>
                                                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2"></line>
                                                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"></line>
                                                </svg>
                                                <div>
                                                    <h3 className="text-sm font-medium">Manage Slots</h3>
                                                    {checkingSlots ? (
                                                        <span className="text-xs text-gray-500">Checking slots...</span>
                                                    ) : hasSubscriptionsWithSlots ? (
                                                        <span className="text-xs text-green-600">Slots available</span>
                                                    ) : (
                                                        <span className="text-xs text-gray-500">No slots defined yet</span>
                                                    )}
                                                </div>
                                            </div>
                                            <Link
                                                to="/slots"
                                                className="text-sm px-3 py-1 bg-cc_brand/10 text-cc_brand rounded-md group-hover:bg-cc_brand group-hover:text-white transition-all duration-200"
                                            >
                                                View
                                            </Link>
                                        </div>
                                    </div>
                                )}

                                {/* Manage Markup Classes Launch Point - Only for Owner and Admin */}
                                {(!activeRole?.role || activeRole?.role === "Administrator") && (
                                    <div 
                                        onClick={() => navigate('/markup-classes')} 
                                        className="bg-gray-50 px-1 py-3 rounded-lg hover:bg-cc_brand/5 transition-all duration-200 group cursor-pointer"
                                    >
                                        <div className="flex justify-between items-center">
                                            <div className="flex items-center gap-3">
                                                <svg className="w-6 h-6 text-cc_brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                                <div>
                                                    <h3 className="text-sm font-medium">Manage Markup Classes</h3>
                                                    {checkingMarkupClasses ? (
                                                        <span className="text-xs text-gray-500">Checking...</span>
                                                    ) : (
                                                        <span className="text-xs text-gray-500">
                                                            {markupClassesCount} today's requests
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <Link
                                                to="/markup-classes"
                                                className="text-sm px-3 py-1 bg-cc_brand/10 text-cc_brand rounded-md group-hover:bg-cc_brand group-hover:text-white transition-all duration-200"
                                            >
                                                Manage
                                            </Link>
                                        </div>
                                    </div>
                                )}


                                {/* My World Launch Point */}
                                <Link 
                                    to="/myworld"
                                    className="bg-gradient-to-r from-blue-50 to-indigo-50 px-1 py-3 rounded-lg hover:from-blue-100 hover:to-indigo-100 transition-all duration-200 group cursor-pointer border border-blue-200 block"
                                >
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-3">
                                            <svg className="w-6 h-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M8 2v4" />
                                                <path d="M16 2v4" />
                                                <path d="M21 6H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z" />
                                                <path d="M3 10h18" />
                                                <path d="M8 14h.01" />
                                                <path d="M12 14h.01" />
                                                <path d="M16 14h.01" />
                                                <path d="M8 18h.01" />
                                                <path d="M12 18h.01" />
                                                <path d="M16 18h.01" />
                                            </svg>
                                            <div>
                                                <h3 className="text-sm font-medium text-blue-800">My World</h3>
                                                <span className="text-xs text-blue-600">Personal attendance tracking & calendar</span>
                                            </div>
                                        </div>
                                        <Button
                                            size="small"
                                            className="text-sm px-3 py-1 bg-blue-600/10 text-blue-700 rounded-md group-hover:bg-blue-600 group-hover:text-white transition-all duration-200"
                                        >
                                            Open
                                        </Button>
                                    </div>
                                </Link>

                                {/* Attendance Summary Launch Point */}
                                <div onClick={() => navigate("/attendance-summary")} className="bg-gray-50 px-1 py-3 rounded-lg hover:bg-cc_brand/5 transition-all duration-200 group cursor-pointer">
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-3">
                                            <svg className="w-6 h-6 text-cc_brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 12L11 14L15 10M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <h3 className="text-sm font-medium">Attendance</h3>
                                        </div>
                                        <Link
                                            to="/attendance-summary"
                                            className="text-sm px-3 py-1 bg-cc_brand/10 text-cc_brand rounded-md group-hover:bg-cc_brand group-hover:text-white transition-all duration-200"
                                        >
                                            Manage
                                        </Link>
                                    </div>
                                </div>

                                {/* Orders Launch Point */}
                                <div onClick={() => navigate("/orders")} className="bg-gray-50 px-1 py-3 rounded-lg hover:bg-cc_brand/5 transition-all duration-200 group cursor-pointer">
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-3">
                                            <svg className="w-6 h-6 text-cc_brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V5M9 5H15M9 12H15M9 16H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <h3 className="text-sm font-medium">Orders</h3>
                                        </div>
                                        <Link
                                            to="/orders"
                                            className="text-sm px-3 py-1 bg-cc_brand/10 text-cc_brand rounded-md group-hover:bg-cc_brand group-hover:text-white transition-all duration-200"
                                        >
                                            View
                                        </Link>
                                    </div>
                                </div>

                                {/* Raise Invoice Launch Point */}
                                <div onClick={() => dispatch(openModal("RaiseInvoiceModalOpen"))} className="bg-gray-50 px-1 py-3 rounded-lg hover:bg-cc_brand/5 transition-all duration-200 group cursor-pointer">
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-3">
                                            <ReceiptOutlinedIcon className="text-cc_brand" />
                                            <h3 className="text-sm font-medium">Raise Invoice</h3>
                                        </div>
                                        <button
                                            className="text-sm px-3 py-1 bg-cc_brand/10 text-cc_brand rounded-md group-hover:bg-cc_brand group-hover:text-white transition-all duration-200"
                                        >
                                            Raise
                                        </button>
                                    </div>
                                </div>

                                {/* Bulk Invoicing Launch Point */}
                                <div onClick={() => navigate('/bulkrequests')} className="bg-gray-50 px-1 py-3 rounded-lg hover:bg-cc_brand/5 transition-all duration-200 group cursor-pointer">
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-3">
                                            <ReceiptLongOutlinedIcon className="text-cc_brand" />
                                            <h3 className="text-sm font-medium">Bulk Invoicing</h3>
                                        </div>
                                        <div className="text-sm cursor-pointer px-3 py-1 bg-cc_brand/10 text-cc_brand rounded-md group-hover:bg-cc_brand group-hover:text-white transition-all duration-200">
                                            Generate
                                        </div>
                                    </div>
                                </div>

                                {/* Bulk Reminders Launch Point */}
                                <div onClick={() => navigate('/bulkrequests')} className="bg-gray-50 px-1 py-3 rounded-lg hover:bg-cc_brand/5 transition-all duration-200 group cursor-pointer">
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-3">
                                            <HistoryIcon className="text-cc_brand" />
                                            <h3 className="text-sm font-medium">Bulk Reminders</h3>
                                        </div>
                                        <div className="text-sm cursor-pointer px-3 py-1 bg-cc_brand/10 text-cc_brand rounded-md group-hover:bg-cc_brand group-hover:text-white transition-all duration-200">
                                            Send
                                        </div>
                                    </div>
                                </div>
                            </div> : <div className="space-y-3">
                                {/* My World Launch Point - For Observer role */}
                                <Link 
                                    to="/myworld"
                                    className="bg-gradient-to-r from-blue-50 to-indigo-50 px-1 py-3 rounded-lg hover:from-blue-100 hover:to-indigo-100 transition-all duration-200 group cursor-pointer border border-blue-200 block"
                                >
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-3">
                                            <svg className="w-6 h-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M8 2v4" />
                                                <path d="M16 2v4" />
                                                <path d="M21 6H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z" />
                                                <path d="M3 10h18" />
                                                <path d="M8 14h.01" />
                                                <path d="M12 14h.01" />
                                                <path d="M16 14h.01" />
                                                <path d="M8 18h.01" />
                                                <path d="M12 18h.01" />
                                                <path d="M16 18h.01" />
                                            </svg>
                                            <div>
                                                <h3 className="text-sm font-medium text-blue-800">My World</h3>
                                                <span className="text-xs text-blue-600">Personal attendance tracking & calendar</span>
                                            </div>
                                        </div>
                                        <Button
                                            size="small"
                                            className="text-sm px-3 py-1 bg-blue-600/10 text-blue-700 rounded-md group-hover:bg-blue-600 group-hover:text-white transition-all duration-200"
                                        >
                                            Open
                                        </Button>
                                    </div>
                                </Link>

                                {/* Attendance Summary Launch Point */}
                                <div onClick={() => navigate("/attendance-summary")} className="bg-gray-50 px-1 py-3 rounded-lg hover:bg-cc_brand/5 transition-all duration-200 group cursor-pointer">
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-3">
                                            <svg className="w-6 h-6 text-cc_brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 12L11 14L15 10M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12 C21 7.02944 16.9706 3 12 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <h3 className="text-sm font-medium">Attendance</h3>
                                        </div>
                                        <Link
                                            to="/attendance-summary"
                                            className="text-sm px-3 py-1 bg-cc_brand/10 text-cc_brand rounded-md group-hover:bg-cc_brand group-hover:text-white transition-all duration-200"
                                        >
                                            Manage
                                        </Link>
                                    </div>
                                </div>


                            </div>}
                        </div>

                        {/*-----------------YourBankAccounts--------------*/}
                        {activeRole?.role !== "Observer" && <YourAccounts />}
                    </div>
                </div>
            </div>

        </div>
    )
}